import {Component, OnInit} from '@angular/core';
import {AlertService} from '../../service/alert.service';

@Component({
  selector: 'faq-alert',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {

  constructor(private alertService: AlertService) {
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/view/faq/faq.component.ts